import { useState, useEffect } from 'react';
import { buildKpiQuery } from '../utils/influenceKpis';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// state: {loading, error, data}. data.available === false is a normal answer (custom range, event filter, no row yet).
// `enabled: false` skips the request (the page has nothing to ask for yet).
export default function useInfluenceKpis(params, enabled = true) {
  const [state, setState] = useState({ loading: enabled, error: null, data: null });
  const query = buildKpiQuery(params || {});
  useEffect(() => {
    if (!enabled) {
      setState({ loading: false, error: null, data: null });
      return undefined;
    }
    let live = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    fetch(`${API_BASE_URL}/exec/influence/kpis?${query}`, { credentials: 'include' })
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((data) => { if (live) setState({ loading: false, error: null, data }); })
      .catch((e) => { if (live) setState({ loading: false, error: e.message, data: null }); });
    return () => { live = false; };
  }, [query, enabled]);
  return state;
}
